import _uniq from 'lodash/uniq';

import { type Page } from 'consts/pages';
import { collapseLeadingTimeframes } from 'utils/pql';

export const HISTORY_LIMIT = 20;

export const getPageQueryHistory = (page: Page): string[] => {
  const item = localStorage.getItem(`${page}-history`);

  if (item) {
    const history = (JSON.parse(item) || []) as string[];
    return _uniq(history.map(collapseLeadingTimeframes));
  }

  return [];
};

export const savePageQueryHistory = (page: Page, history: string[]) => {
  localStorage.setItem(`${page}-history`, JSON.stringify(history));
};
